// JQUERY //
// import $ from "jquery";

// BOOTSTRAP //
import {
    Dropdown,
    Collapse,
    Modal,
    Tab,
    ScrollSpy,
    Offcanvas,
    Popover,
} from 'bootstrap';

// IMPORTS //
import './custom/contain';

// Variabili
let scrollPosition = window.scrollY;
let body = document.querySelector('body');

// Funzioni header
let header = document.querySelector('header');
let headerH = header.clientHeight;

let pageMenu = document.querySelector('.page-menu');

// Popovers
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
    return new Popover(popoverTriggerEl)
})

// Disable popovers on touch
function isTouchDevice() {
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}

// Riduce header post scroll
window.onload = function() {
    minifyHeader()
};
window.onscroll = function() {
    minifyHeader()
};

function minifyHeader() {
    if (document.body.scrollTop > headerH / 2 || document.documentElement.scrollTop > headerH / 2) {
        body.classList.add('minified');
    } else {
        body.classList.remove('minified');
    }
}

// Focus su campo di ricerca
const searchPanel = document.getElementById('search-panel')
searchPanel.addEventListener('shown.bs.collapse', function() {
    searchPanel.querySelector('.form-control').focus();
})

// PLUGINS //
// Lazysizes
import lazySizes from 'lazysizes';

// Lightbox
import GLightbox from 'glightbox';
const lightbox = GLightbox({
    loop: true
});

// Single Lightbox
const singleLightbox = GLightbox({
    loop: false
});

const singleLightboxElements = document.querySelectorAll('.glightbox-single');
if (singleLightboxElements) {
    singleLightboxElements.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            let targetHref = this.getAttribute('href');
            singleLightbox.setElements([{
                'href': targetHref
            }]);
            singleLightbox.open();
        })
    })
}

// Aos
// import AOS from 'aos';
// AOS.init({
//     duration: 200,
//     once: true,
// });

// Smooth Scroll
// import SmoothScroll from 'smooth-scroll';
// import Gumshoe from 'gumshoejs';

// Plyr
import Plyr from 'plyr';
const yt_player = Plyr.setup('.video-player', {
    controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen'
    ],
    youtube: {
        noCookie: true,
        rel: 0,
        showinfo: 0,
        modestbranding: 1
    },
    vimeo: {
        byline: false,
        portrait: false,
        title: false,
        speed: true,
        transparent: false
    }
});
const yt_player_home = Plyr.setup('.video-player-home', {
    controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen'
    ],
    youtube: {
        noCookie: true,
        rel: 0,
        showinfo: 0,
        modestbranding: 1
    },
    vimeo: {
        byline: false,
        portrait: false,
        title: false,
        speed: true,
        transparent: false
    },
    muted: true,
});

// Swiper
import Swiper, {
    Navigation,
    Pagination,
    Autoplay
} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

// Homepage Slider
let homepage_slider = new Swiper(".homepage-slider", {
    loop: true,
    spaceBetween: 0,
    allowTouchMove: true,
    speed: 1000,
    // autoplay: {
    //     delay: 7000,
    // },
    pagination: {
        el: '.visual-pagination',
        type: 'bullets',
        clickable: true,
        bulletClass: 'bullet',
        bulletActiveClass: 'active'
    },
});

// Gallery Slider
let gallerySlider = new Swiper('.gallery-slider', {
    spaceBetween: 32,
    autoHeight: false,
    loop: true,
    watchOverflow: true,
    speed: 500,
    // pagination: {
    //     el: '.gallery-pagination',
    //     type: 'bullets',
    //     clickable: true,
    // },
    navigation: {
        nextEl: ".gallery-nav.next",
        prevEl: ".gallery-nav.prev",
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        }
    }
});

// Hotspot Slider
let hotspotSlider = new Swiper('.hotspot-slider', {
    spaceBetween: 0,
    autoHeight: false,
    loop: true,
    watchOverflow: true,
    speed: 500,
    slidesPerView: 1,
    navigation: {
        nextEl: ".hotspot-nav.next",
        prevEl: ".hotspot-nav.prev",
    },
});

// Form floater
let formFields = document.querySelectorAll('.form-float .form-control, .form-float .form-select');

formFields.forEach(function(el) {

    // Imposta placeholder
    el.setAttribute('placeholder', '');
    // Aggiunge classe di BS5
    el.parentNode.classList.add('form-floating')
    // Prende il tag label
    let label = el.parentNode.parentNode.querySelector("label");
    // Sposta label nello stesso nodo dell'input
    el.parentNode.append(label)

});

// Accordion repositioner
const accordionItems = document.querySelectorAll('.accordion-collapse');
const accordionWrapper = document.querySelector('.accordion');

accordionItems.forEach((el) => {
    el.addEventListener('shown.bs.collapse', (e) => {
        let headerHeight = document.querySelector('.header').clientHeight;
        let scrollOffset = accordionWrapper.scrollTop + el.parentNode.offsetTop - headerHeight;
        // console.log(scrollOffset);
        window.scroll({
            top: scrollOffset,
            left: 0,
            behavior: 'smooth'
        });
    })
});

// Scrollspy
if (pageMenu) {
    let scrollSpy = new ScrollSpy(document.body, {
        target: '.scrollspy',
        offset: headerHeight + extraHeight + 1,
    })
}

// Megamenu
const megamenus = document.querySelectorAll('[data-megamenu]');

function initTab(elem) {
    document.addEventListener('mouseover', function(e) {
        if (!e.target.matches(elem + ' .m-trigger')) return;
        else {
            if (!e.target.classList.contains('m-active')) {
                findActiveElementAndRemoveIt(elem + ' .m-trigger');
                findActiveElementAndRemoveIt(elem + ' .m-panel');
                e.target.classList.add('m-active');
                let panel = document.querySelectorAll(elem + ' .m-panel#' + e.target.dataset.name);
                Array.prototype.forEach.call(panel, function(el) {
                    el.classList.add('m-active');
                });
            }
        }
    });
}

function findActiveElementAndRemoveIt(elem) {
    let elementList = document.querySelectorAll(elem);
    Array.prototype.forEach.call(elementList, function(e) {
        e.classList.remove('m-active');
    });
}

megamenus.forEach(function(el) {
    let megaID = el.getAttribute('data-megamenu');
    // console.log(megaID);
    initTab('[data-megamenu=' + megaID + ']')
});


// BIZEN
document.addEventListener("DOMContentLoaded", function() {
    console.log('A DIGITAL PROJECT BY\n\r······································································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo······················oooo·······································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo····oooooo············oooo······oooooooooooooooo·········ooooooooo···············oooooooooo······\n\r·oooooooooooooooooo········oooo·····ooooooooooooooooo······ooooooooooooooo·········oooooooooooooooo···\n\r·oooooooo······ooooo·······oooo················ooooo·····ooooo·········ooooo·····ooooo··········ooooo·\n\r·ooooo···········ooooo·····oooo··············ooooo······ooooo···········ooooo····ooo·············oooo·\n\r·oooo·············oooo·····oooo·············ooooo·······ooooooooooooooooooooo···oooo··············ooo·\n\r·oooo·············oooo·····oooo···········ooooo·········oooo····················oooo··············ooo·\n\r·oooo·············oooo·····oooo··········oooo···········oooo····················oooo··············ooo·\n\r··ooooo·········ooooo······oooo········ooooo·············oooo···········oooo····oooo··············ooo·\n\r····oooooooooooooooo·······oooo······ooooooooooooooo······oooooo······ooooo·····oooo··············ooo·\n\r·······oooooooooo··········oooo·····ooooooooooooooooo········oooooooooooo·······oooo··············ooo·\n\r······································································································\n\r');
});